export default class RequirementRelateController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/requirementRelate/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/startOnly/flowRequirementRelateAudit', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/startWithBusinessKey/flowRequirementRelateAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/startAndTakeUserTask/flowRequirementRelateAudit', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/startAndSaveDraft/flowRequirementRelateAudit', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/submitUserTask/flowRequirementRelateAudit', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/viewTaskBusinessData/flowRequirementRelateAudit', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/viewHistoricTaskBusinessData/flowRequirementRelateAudit', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowRequirementRelateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/requirementRelate/listWorkOrder/flowRequirementRelateAudit', 'post', params, axiosOption, httpOption);
  }
}
